// 1) Routing is the process of matching a URL to a view. A view is a set of components to be  rendered. Routing is responsible for loading and unloading content by matching the URL to a set of components that need to be rendered. In a single page app this is all done  without reloading the page. React does not have a built in routing features so developers have built React-Router an external library. A good routing system should also keep track of browser history. User should be  able to navigate the app using the back and forward buttons. SPAs should work in a way that is consistant with multi-page apps.

// 2) Navigate to the  project folder in terminal and run > 'NPM install' to install all of  the course dependencies. This will load the 'node_modules' directory.

// 3) Now launch the app by running 'npm start'

// 4) react-router has separate packages for either web or native app development. Since we are creating a web app we will need to install 'react-router-dom'. In terminal stop the web server 'control c' Then instal react-router-dom by typing in:
// 'npm install --save react-router-dom'

// 5) react-router-dom gives you two new coumponents that are  used to  build routes: 'BrowserRouter' (The route routing componet, which keeps your UI in sync with the URL)
// and ...
//  'Route' (Which  is  responible for rendering a component in your app when a URL matchs its path.)

// (( Go to App.js ))

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './css/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js